// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"1c69eb5f","229":"967b151f","361":"10d7fae6","449":"e4314239","727":"e81d3d5e","839":"0643eb72"}[chunkId] + ".chunk.js";
};